module.exports = __webpack_public_path__ + "static/media/codec.5e2c5bac.flac";